import { render, staticRenderFns } from "./RTL.vue?vue&type=template&id=3f31f88c&"
import script from "./RTL.vue?vue&type=script&lang=js&"
export * from "./RTL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports